import * as React from 'react';
import styled from 'styled-components';
import logo from '../../assets/sunbit-logo-blue.svg';
import LinkButton from '../../components/linkButton/LinkButton';
import StyledLink from '../../components/StyledLink/styledLink';

import thumb from '../../assets/thumb.svg';

// ############################ Styles ###########################
// tslint:disable:variable-name

const STopContainer = styled.header`
  top: 0;
  left: 0;
  height: 60px;
  position: absolute;
`;

const STop = styled.div(
  ({ theme }) => `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  @media only screen and ${theme.device.max.laptopS} {
    box-shadow: 3px 3px 7px 0 rgba(0, 0, 0, 0.16);
    background: ${theme.colors.white};
  }
`
);

const STopBarSection = styled.section(
  ({ theme }) => `
  background-color: ${theme.colors.white};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding:0 ${theme.spacing.large2}px;
  box-shadow: 3px 3px 7px 0 rgba(0, 0, 0, 0.16);
  @media only screen and (min-width: 800px) {
    padding:0 ${theme.spacing.small}px;
    border-radius: ${theme.borderRadiusCommon}px ${theme.borderRadiusCommon}px 0 0;
  }
  @media only screen and ${theme.device.max.laptopS} {
    box-shadow: none;
  }
`
);

const STopBarInnerSection = styled.div<{ align? }>(
  ({ align }) => `
  display: flex;
  flex-direction: row;
  justify-content: ${align === 'right' ? 'flex-end' : 'flex-start'};
  align-items: center;
  padding:0;
  width: 340px;
`
);

const SLogoModalSection = styled.section(
  ({ theme }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 43px;
  padding:5px ${theme.spacing.large2}px;
  box-sizing: content-box;
  &:after {
    content: 'Developer';
    color: ${theme.colors.mediumGray};
    font-family: Poppins;
    font-style: italic;
    font-weight: ${theme.font.weight.medium};
    font-size: 20px;
    height: 10px;
    line-height: 20px;
    padding-left: 5px;
  }
  @media only screen and (min-width: 800px) {
    height: 50px;
  }
`
);

const SLogoSection = styled(SLogoModalSection as any)(
  () => `
  padding: 0;
  @media only screen and (min-width: 800px) {
    border-radius: 0;
  }
`
);

const SDropdown = styled.div(
  ({ theme }) => `
  font-weight: ${theme.font.weight.bold};
  color: ${theme.colors.primaryBackground};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
  &:after {
    content: '';
    border: solid ${theme.colors.primaryBackground};
        border-width: 0 1px 1px 0;
        display: inline-block;
        padding: 3px;
        margin: 10px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        cursor: pointer;
  }
`
);

// const SNavSection = styled.nav<{}>(({ theme }) => `
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   height: 40px;
//   border-bottom: 2px solid ${theme.colors.border};
//   padding: 0 ${theme.spacing.large2}px;
//   @media only screen and (min-width: 800px) {
//     padding: 0 ${theme.spacing.huge}px;
//   }
// `);

const SLinksSection = styled.nav`
  position: relative;
`;

const SLinksMenu = styled(LinkButton as any)`
  @media only screen and (min-width: 800px) {
    display: none;
  }
`;

const SLinksSectionInner = styled.div<{ isVisible: boolean }>(
  ({ theme, isVisible }) => `
  display: ${isVisible ? 'flex' : 'none'};
  flex-direction: column;
  background: white;
  position: absolute;
  top: 100%;
  right: 0;
  width: 150px;
  padding: ${theme.spacing.medium}px;
  border-radius: ${theme.borderRadiusCommon}px;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.12);
  > a:not(:last-child) {
    margin-bottom: ${theme.spacing.small}px;
  }
  @media only screen and (min-width: 800px) {
    background: transparent;
    display: flex;
    flex-direction: row;
    position: static;
    width: auto;
    padding: 0;
    border-radius: none;
    box-shadow: none;
    > a:not(:last-child) {
      margin-bottom: 0 !important;
      margin-right: ${theme.spacing.large}px;
    }
  }
`
);

const SHiddenEelement = styled.span`
  width: 100px;

  &:focus {
    outline: 2px solid red;
  }
`;

const SLogo = styled.a`
  > img {
    width: 100%;
    height: 100%;
    display: inline-block;
  }

  width: 99px;
  height: 30px;
  @media only screen and (min-width: 800px) {
    width: 116px;
    height: 35px;
  }
`;

const SProfileThumb = styled.img(
  () => `
  margin: 0 10px;
  width: 15px;
  height: 20px;
  background-size: contain;
`
);

const SDeveloperDocuments = styled(StyledLink)(
  () => `
  white-space: nowrap;
  margin-right: 25px;
`
);

const STitle = styled.div<{}>(
  ({ theme }) => `
  font-family: Poppins;
    font-size: 14px;
    line-height: 38px;
    color: ${theme.colors.primaryBright};
    padding-bottom: 5px;
    padding-top: 17px;
`
);

const STopMenueContainer = styled.div(
  ({ theme }) => `
position: absolute;
    top: 62px;
    right: 0;
    border-bottom-left-radius: ${theme.borderRadiusCommon}px;
    background: white;
    box-shadow: 0px 4px 5px 0 rgb(24 39 75 / 9%), 21px 17px 25px -15px rgb(24 39 75 / 10%);
    font-size: ${theme.font.size.small};
    font-weight: ${theme.font.weight.light};
    height: 50px;
    transition: all 0.5s;
    overflow: hidden;
    width: 160px;
    display: flex;
    opacity: 1;
    justify-content: center;
    align-items: center;
    cursor: pointer;

  &.hidden {
    height: 0;
    opacity: 0;
    transition: all 0.5s;
  }
`
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

export interface ITopProps {
  privacyPolicyUrl: string;
  termsOfUseUrl: string;
  ratesAndTermsUrl: string;
  logout?: () => void;
  headerReturnClick?: () => void;
  headerContactSupportClick?: () => void;
  headerProfileThumbClick?: () => void;
  headerReturnText?: string;
  showNavigation?: boolean;
  isModal?: boolean;
  headerTitleText?: string;
  showProfileThumb?: boolean;
  showDeveloperDocuments?: boolean;
  username: string;
}

interface ITopState {
  linksMenuVisible: boolean;
  topMenuVisible: boolean;
}

export default class Top extends React.Component<ITopProps, ITopState> {
  private hiddenElement = React.createRef<HTMLSpanElement>();

  public static defaultProps = {
    showNavigation: true,
    isModal: true,
    headerTitleText: '',
  };

  public state = {
    linksMenuVisible: false,
    topMenuVisible: false,
  };

  public componentDidMount() {
    if (this.hiddenElement?.current) {
      this.hiddenElement.current.focus();
    }
  }

  private toggleTopMenue = () => {
    this.setState(() => ({ topMenuVisible: !this.state.topMenuVisible }));
  };

  private toggleLinksMenu = () => {
    this.setState(() => ({ linksMenuVisible: !this.state.linksMenuVisible }));
  };

  public render() {
    // let nav: React.ReactNode = null;
    let logoBar: React.ReactNode = null;

    // tslint:disable-next-line:variable-name
    const accessibilityHelperElement = <SHiddenEelement ref={this.hiddenElement} tabIndex={0} />;
    const logoRender = (
      <SLogo href="https://www.sunbit.com" data-at="sunbitLogoLink" target="_blank">
        <img src={logo} alt="sunbit logo" />
      </SLogo>
    );

    const linksSection = (
      <SLinksSection>
        <SLinksMenu onClick={this.toggleLinksMenu}>
          <i className="material-icons">more_vert</i>
        </SLinksMenu>
        <SLinksSectionInner isVisible={this.state.linksMenuVisible}>
          <StyledLink
            data-at="privacyPolicyLinkNoNavigation"
            key="privacyPolicy"
            href={this.props.privacyPolicyUrl}
            target="_blank"
          >
            Privacy Policy
          </StyledLink>
          <StyledLink
            data-at="termsOfUseLinkNoNavigation"
            key="termsOfUse"
            href={this.props.termsOfUseUrl}
            target="_blank"
          >
            Terms of Use
          </StyledLink>
          <StyledLink
            data-at="ratesAndTermsLinkNoNavigation"
            key="rateAndTerms"
            href={this.props.ratesAndTermsUrl}
            target="_blank"
          >
            Rates & Terms
          </StyledLink>
        </SLinksSectionInner>
      </SLinksSection>
    );

    if (this.props.showNavigation) {
      logoBar = this.props.isModal ? (
        <SLogoModalSection>{logoRender}</SLogoModalSection>
      ) : (
        <SLogoSection>{logoRender}</SLogoSection>
      );

      // nav = (
      //   <SNavSection>
      //       <LinkButton />
      //     {linksSection}
      //   </SNavSection>
      // );
    } else {
      logoBar = this.props.isModal ? (
        <SLogoModalSection>
          {logoRender}
          {linksSection}
        </SLogoModalSection>
      ) : (
        <SLogoSection>
          {logoRender}
          {linksSection}
        </SLogoSection>
      );
    }

    return (
      <STopContainer>
        <STop>
          {accessibilityHelperElement}
          <STopBarSection>
            <STopBarInnerSection>
              {logoBar}
              {this.props.headerTitleText && <STitle>{this.props.headerTitleText}</STitle>}
            </STopBarInnerSection>

            <STopBarInnerSection align="right">
              {this.props.showDeveloperDocuments && (
                <SDeveloperDocuments href="/docs" target="_blank">
                  Partner with Sunbit
                </SDeveloperDocuments>
              )}
              {this.props.logout && (
                <SDropdown onClick={this.toggleTopMenue}>
                  <SProfileThumb
                    id="headerProfileThumbButton"
                    data-at="headerProfileThumbAction"
                    onClick={this.props.headerProfileThumbClick}
                    src={thumb}
                  />
                  {this.props.username}
                </SDropdown>
              )}
              <STopMenueContainer className={this.state.topMenuVisible ? '' : 'hidden'}>
                <div onClick={this.props.logout}>Logout</div>
              </STopMenueContainer>
            </STopBarInnerSection>
          </STopBarSection>
        </STop>
      </STopContainer>
    );
  }
}
